import React from 'react'

function SurveySide() {
  return (
    <div>
      
    </div>
  )
}

export default SurveySide
